import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import { proofImages } from '../data/proofImages';
type Review = {
  name: string;
  role: string;
  content: string;
  avatar: string | null;
  avatarPosition?: string;
};
const reviews: Review[] = [{
  name: 'Liliana Leal',
  role: 'Cliente Verificada',
  content: 'Altamente recomendado, servicio excepcional y con muy buena atención. Gracias a Eduardo y a su equipo mi crédito está excelente y ya estoy buscando capital para mi negocio.',
  avatar: 'https://cdn.magicpatterns.com/uploads/hJXdKb1Zim1tL1u7PKF42S/IMG_0415.jpg',
  avatarPosition: 'object-[20%_35%]'
}, {
  name: 'Liliana Rodriguez',
  role: 'Cliente Verificada',
  content: 'Gracias a la asesoría de Edu, logré obtener hasta 40.000 dólares en mi primera tarjeta de crédito de negocios con Chase. Increíble resultado. ¿Mi consejo? Déjense guiar del mejor.',
  avatar: 'https://cdn.magicpatterns.com/uploads/6Eiyt6b2wk5nugeq5wJ1Eh/IMG_0818.jpg'
}, {
  name: 'Edgar Morales',
  role: 'Cliente Verificado',
  content: 'Tenía 7 collections en mi reporte de crédito y Eduardo y su equipo las removieron todas en menos de 60 días. Un resultado increíble, me sorprendió. Se los recomiendo a todos.',
  avatar: 'https://cdn.magicpatterns.com/uploads/4rr4pee8LoLBE4Rgz6MsKS/IMG_0819.jpg'
}, {
  name: 'Leonardo Cuello',
  role: 'Propietario de Casa',
  content: 'No podía comprar mi casa hasta que Eduardo y el equipo de Vantix me ayudaron. Literalmente no podía cerrar el negocio porque mi puntaje no estaba bien; luego lo arreglamos y ahora voy por mi segunda casa.',
  avatar: 'https://cdn.magicpatterns.com/uploads/gwsbtdrRTYn5J3CCGfeR2z/IMG_0820.jpg'
}, {
  name: 'Juan Soto',
  role: 'Cliente Verificado',
  content: 'Atención excelente, recomendados al 100%.',
  avatar: 'https://cdn.magicpatterns.com/uploads/tjQxQtsc2cSbqyDTqq7foW/IMG_0821.jpg'
}];
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <article className="flex flex-col w-[300px] sm:w-[360px] shrink-0 p-8 rounded-3xl bg-zinc-950 border border-white/[0.08] hover:border-amber-500/20 transition-colors duration-500" data-id="element-208" data-mp="1r47kgv5h8egq">
      {/* Top row: stars + quote icon */}
      <div className="flex items-start justify-between mb-6" data-id="element-209" data-mp="1hdmbqew39tk3">
        <div className="flex gap-1" data-id="element-210" data-mp="13ewg73ox41xu">
          {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-211" data-mp="13gzfkebyn7f8" data-mpi={i} />)}
        </div>
        <Quote className="h-8 w-8 text-amber-500/15 fill-amber-500/10" data-id="element-212" data-mp="18bmtjj9c8jfk" />
      </div>

      {/* Quote */}
      <p className="italic text-white/60 font-light leading-relaxed text-[15px] mb-8 flex-grow" data-id="element-213" data-mp="tj36ds2l2mjr">
        "{review.content}"
      </p>

      {/* Divider */}
      <div className="h-px w-full bg-white/[0.08] mb-6" data-id="element-214" data-mp="2nw1bzydc8v0r" />

      {/* Author */}
      <div className="flex items-center gap-3" data-id="element-215" data-mp="2su2xsr25f8fx">
        <div className="h-11 w-11 rounded-full bg-gradient-to-br from-zinc-700 to-zinc-900 border border-white/10 flex items-center justify-center text-white font-semibold text-sm shrink-0 overflow-hidden" data-id="element-216" data-mp="2srqeoaknms1a">
          {review.avatar ? <img src={review.avatar} alt={review.name} className={`h-full w-full object-cover ${review.avatarPosition ?? ''}`} data-id="element-217" data-mp="qwspkcy3emqs" /> : review.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
        </div>
        <div data-id="element-218" data-mp="vxge8ryumrhu">
          <div className="text-white font-semibold leading-tight" data-id="element-219" data-mp="vxq84qn0list">
            {review.name}
          </div>
          <div className="text-sm text-white/40" data-id="element-220" data-mp="14w21h0f9muoy">{review.role}</div>
        </div>
      </div>
    </article>;
}
export function Reviews() {
  // Duplicated once so the track can loop seamlessly at -50%
  const loop = [...reviews, ...reviews];
  const imageLoop = [...proofImages, ...proofImages];
  return <section id="resultados" className="py-20 md:py-24 bg-black border-t border-white/5 relative overflow-hidden" data-id="element-221" data-mp="384uampu7l28b">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-222" data-mp="3d2dq1t2n7l1u" />

      <div className="relative z-10" data-id="element-223" data-mp="3i0p3eds5cdot">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-14 md:mb-16" data-id="element-224" data-mp="3n2e9rg4fc36k">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-225" data-mp="3453b9xqm9ds6">
            Resultados Comprobados
          </span>
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-226" data-mp="srbh1cuxd9at">
            Ellos confiaron,{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-227" data-mp="oqhqebq3lge8">
              dijeron que sí
            </span>{' '}
            y acá están sus resultados
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-228" data-mp="9spgq078fm7y">
            Mira lo que sucede cuando dejas de esperar y tomas acción con
            Vantix.
          </p>
        </motion.div>

        {/* Infinite marquee */}
        <div className="marquee-viewport relative overflow-hidden" data-id="element-229" data-mp="10x7ttxuwl5h">
          {/* Edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-40 z-10 bg-gradient-to-r from-black to-transparent" data-id="element-230" data-mp="3s801qt52x5je" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-40 z-10 bg-gradient-to-l from-black to-transparent" data-id="element-231" data-mp="3n9gaqebmp3k6" />

          <div className="marquee-track flex gap-6 w-max px-3" data-id="element-232" data-mp="38knag3ery7hq">
            {loop.map((review, index) => <ReviewCard key={index} review={review} data-id="element-233" data-mp="3dl17kqeu7x0z" data-mpi={index} />)}
          </div>
        </div>

        {/* Second marquee — images, scrolling the opposite way */}
        <div className="marquee-viewport relative overflow-hidden mt-6" data-id="element-234" data-mp="33lk48fn25v86">
          {/* Edge fades */}
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-40 z-10 bg-gradient-to-r from-black to-transparent" data-id="element-235" data-mp="3rbo5whgorkwj" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-40 z-10 bg-gradient-to-l from-black to-transparent" data-id="element-236" data-mp="3s94sdmkv5r" />

          <div className="marquee-track-reverse flex gap-6 w-max px-3" data-id="element-237" data-mp="3ih9uipza0uip">
            {imageLoop.map((image, index) => <div key={index} className="h-[380px] sm:h-[480px] shrink-0 rounded-3xl overflow-hidden bg-zinc-950 border border-white/[0.08] hover:border-amber-500/20 transition-colors duration-500" data-id="element-238" data-mp="e54mcw1eiiny" data-mpi={index}>
                <img src={image.src} alt={image.alt} loading="lazy" className="h-full w-auto block object-cover" data-id="element-239" data-mp="23kfd53ze9jiv" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}